module.exports = __webpack_public_path__ + "static/media/how-qr-works-4.5a4a2850.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/how-qr-works-4.png
// module id = 367
// module chunks = 3